import { Component, CUSTOM_ELEMENTS_SCHEMA, Inject } from '@angular/core';

import { ExpenseBO } from '@skylab-shared/business';
import { EventBusBase } from '@skylab-shared/core';
import { ExpenseModel } from '@skylab-shared/dataModel';

import { ExpenseRepository, ExpenseRepositoryBase } from '@skylab-angular-shared/business';
import { CommandBus, EventBus, L10n, L10nBase, RootContext, RootContextBase, Weaver, WeaverBase } from '@skylab-angular-shared/core';
import { ButtonComponent, DialogContentComponentIns, DialogHeaderComponentIns, DialogInsService, FocusByDirective, FormContainerComponent, TextValueAccessorDirective, ToastService, ValidateDirective, ValidationSourceDirective } from '@skylab-angular-shared/ui';

import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@skylab-angular-shared/pipes';
import { DictionaryDialogComponentBase, DictionaryDialogViewModelBase } from '../dictionary-dialog-base';

export interface ExpenseDialogResult {
    id: number;
    version: string;
}

interface ExpenseConfigurationViewModel extends DictionaryDialogViewModelBase<ExpenseBO> {}

@Component({
    selector: 'skl-expense-dialog',
    templateUrl: './expense-dialog.component.html',
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [DialogContentComponentIns, DialogHeaderComponentIns, FormContainerComponent, ValidationSourceDirective, TextValueAccessorDirective, FocusByDirective, FormsModule, ValidateDirective, ButtonComponent, TranslatePipe]
})
export class ExpenseDialogComponent extends DictionaryDialogComponentBase
<
ExpenseModel,
ExpenseBO,
ExpenseRepositoryBase,
ExpenseConfigurationViewModel
> {
    public constructor(
        @Inject(ExpenseRepository) expenseRepository: ExpenseRepositoryBase,
        @Inject(RootContext) rootContext: RootContextBase,
        @Inject(Weaver) weaver: WeaverBase,
        @Inject(L10n) l10n: L10nBase,
        @Inject(EventBus) eventBus: EventBusBase,

        toastService: ToastService,
        commandBus: CommandBus,
        dialogService: DialogInsService
    ) {
        super(expenseRepository, toastService, l10n, weaver, rootContext, commandBus, eventBus, dialogService);
    }
}
